<template>
  <div class="SecondProduct">
    <MainPageHeader/>
    <div class="content">
      <header>
        <router-link class="back-button" :to="{ name: 'mainPage' }">
          <font-awesome-icon icon="arrow-left"/>
          <p class="font-size-middle">Wyjdź</p>
        </router-link>
      </header>
      <div class="divider"/>
      <ProductDetailsSectionSecondProduct/>
      <div class="divider"/>
      <h1 class="text-header font-size-big" style="padding-bottom: 0; margin-bottom: 0;">
        Sprawdź również <strong>PAKIET Vocale Premium</strong>
      </h1>
      <h4 class="text-header font-size-middle" style="margin-top: 2px; padding-top: 6px">
        z wysokiej klasy tabletem i akcesoriami oraz
        całodobową pomocą techniczną
      </h4>

      <section class="section-2 font-size-middle">

        <p>
          Dzięki niemu zyskasz wszystko to co zawiera <strong>PAKIET Vocale Gold</strong> oraz otrzymasz
          dodatkowo całodobową pomoc techniczną techniczną Premium.
        </p>
        <BigButton class="big-button" borderColor="primary" @click="route({
                    name: 'thirdProduct'
                })">SPRAWDŹ
        </BigButton>
      </section>
      <div class="divider"/>
      <InfoSectionSecondProduct/>
    </div>
    <TabFooter
        :name="productDetails.name"
        :price="productDetails.price"
        :quantity="productDetails.quantity"
        :period="productDetails.period"
        @buttonClicked="route({
                name: 'summaryPage',
                params: { id: '2' },
            })"
    />
    <PageNotFound v-if="loadError" :message="loadError"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import TabFooter from '../components/TabFooter.vue'
import BigButton from '../components/input/BigButton.vue'
import InfoSectionSecondProduct from '../components/infosection/InfoSectionSecondProduct.vue'
import ProductDetailsSectionSecondProduct from '../components/infosection/ProductDetailsSectionSecondProduct.vue'
import { productDatabase } from '@/services/mock/productDatabase'

export default {
  name: 'SecondProduct',
  components: {
    MainPageHeader,
    PageNotFound,
    TabFooter,
    BigButton,
    InfoSectionSecondProduct,
    ProductDetailsSectionSecondProduct,
  },

  data () {
    return {
      productDetails: {
        key: productDatabase[2].key,
        name: productDatabase[2].name,
        price: productDatabase[2].price,
        period: productDatabase[2].period,
        quantity: productDatabase[2].quantity
      },
      successor: null,
      loadError: null,
      description: null,
    }
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  methods: {
    route (location) {
      this.$router.push(location)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.SecondProduct {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}

.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 90px;

  header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto 10px;
    max-width: 1300px;

    .back-button {
      display: flex;
      align-items: center;
      padding: 10px;
      color: white;
      background-color: transparent;
      border-radius: 3px;
      text-decoration: none;

      p {
        display: inline-block;
        margin: 0;
        margin-left: 0.7em;
      }
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    strong {
      color: $primary;
    }
  }

  .section-2 {
    margin: 0 auto;
    max-width: 1200px;
    color: #ccc;
    text-align: center;

    .big-button {
      display: block;
      margin: 30px auto;
    }

    strong {
      color: $primary;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }
}

@media screen and (max-width: 1280px) and (-webkit-min-device-pixel-ratio: 1.1) {
  .content {
    h1 {
      text-align: center;
    }

    .section-tab {
      margin: 50px 0;
      flex-direction: column;
      align-items: center;

      h1 {
        margin: 0px 0 00px 0;
      }

      .info {
        text-align: center;

        .image-placeholder {
          margin: 20px auto;
          width: 500px;
          max-width: 80vw;
        }

        .indented {
          margin: 0;
          margin-top: 30px;
        }
      }

      .image {
        margin: 0px 0 0px 0;

        .image-placeholder {
          width: 500px;
          max-width: 80vw;
        }
      }

      .buttons {
        display: flex;
        flex-direction: column-reverse;

        .mini-button {
          color: white;
          margin: 10px 0;
          padding: 10px 30px;
          border: 1px solid white;
          text-align: center;
        }
      }
    }
  }
}

// Mobile style
@media (max-width: $phone-max-width) {
  .content {
    h1 {
      text-align: center;
    }

    .section-tab {
      margin: 50px 0;
      flex-direction: column;
      align-items: center;

      h1 {
        margin: 0px 0 00px 0;
      }

      .info {
        text-align: center;

        .image-placeholder {
          margin: 20px auto;
          width: 500px;
          max-width: 80vw;
        }

        .indented {
          margin: 0;
          margin-top: 30px;
        }
      }

      .image {
        margin: 0px 0 0px 0;

        .image-placeholder {
          width: 500px;
          max-width: 80vw;
        }
      }

      .buttons {
        display: flex;
        flex-direction: column-reverse;

        .mini-button {
          color: white;
          margin: 10px 0;
          padding: 10px 30px;
          border: 1px solid white;
          text-align: center;
        }
      }
    }
  }
}
</style>
